import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=73bf568c&scoped=true&"
var script = {}
import style0 from "./nav.vue?vue&type=style&index=0&id=73bf568c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf568c",
  null
  
)

export default component.exports